var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.coLoader
    ? _c(
        "v-select",
        {
          staticClass: "search-condition",
          attrs: {
            solo: "",
            "hide-details": "",
            items: _vm.coOptions,
            loading: _vm.dtLoading,
            "no-data-text": _vm.$t(
              _vm.dtLoading ? "LBL_LOADING" : "LBL_SELECTOR_NO_DATA_AVAILABLE"
            ),
            label: _vm.label,
            multiple: _vm.multiple,
            disabled: _vm.disabled,
            readonly: _vm.readonly,
            rules: _vm.coRules,
            clearable: !_vm.multiple
          },
          on: { change: _vm.onChange },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function(data) {
                return [
                  _vm.hasProps
                    ? [
                        _vm._t("selection", null, {
                          item: data.item,
                          index: data.index,
                          selected: data.selected,
                          disabled: data.disabled
                        })
                      ]
                    : [
                        _vm.getVisibility(data.index)
                          ? _c(
                              "v-chip",
                              {
                                staticClass: "chip--select-multi",
                                attrs: {
                                  color: _vm.disabled
                                    ? "greyDark"
                                    : "secondary",
                                  "text-color": "whitePure"
                                }
                              },
                              [
                                _c(
                                  "span",
                                  { attrs: { title: data.item.text } },
                                  [_vm._v(" " + _vm._s(data.item.text) + "...")]
                                ),
                                _vm._v(" "),
                                _vm.extendItemCount >= 1
                                  ? _c("small", {
                                      staticStyle: { "margin-left": "5px" },
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$tc(
                                            "LBL_OTHER_ITEMS",
                                            _vm.extendItemCount,
                                            { number: _vm.extendItemCount }
                                          )
                                        )
                                      }
                                    })
                                  : _vm._e()
                              ]
                            )
                          : _vm._e()
                      ]
                ]
              }
            }
          ]),
          model: {
            value: _vm.vModel,
            callback: function($$v) {
              _vm.vModel = $$v
            },
            expression: "vModel"
          }
        },
        [
          _c(
            "v-list-tile",
            {
              staticClass: "search-condition__input-container",
              attrs: { slot: "prepend-item" },
              slot: "prepend-item"
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.dtSearch,
                    expression: "dtSearch"
                  }
                ],
                staticClass: "search-condition__input",
                attrs: { type: "text", placeholder: _vm.placeholder },
                domProps: { value: _vm.dtSearch },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.dtSearch = $event.target.value
                    },
                    _vm.handleFilter
                  ]
                }
              })
            ]
          )
        ],
        1
      )
    : _c("div", [_vm._t("loader")], 2)
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8ca1c3f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8ca1c3f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/condition-selector/template.html
// module id = null
// module chunks = 